@import '../../style/index';

@include host {
  .headline {
    margin: 0;
    color: var(--colors-dark-base);
    hyphens: initial;
    word-wrap: break-word;

    @for $i from 1 to 6 {
      &--#{$i} {
        @if $i == 1 {
          @include headline-1;
        }

        @if $i == 2 {
          @include headline-2;
        }

        @if $i == 3 {
          @include headline-3;
        }

        @if $i == 4 {
          @include headline-4;
        }

        @if $i == 5 {
          @include headline-5;
        }
      }

      &--xl {
        @include headline-xl;
      }
    }

    rcm-icon {
      display: inline-block;
    }

    &--bold {
      font-family: $font-family-semibold;
    }

    &--light {
      font-family: $font-family-light;
    }

    &--regular {
      font-family: $font-family-regular;
    }

    &--bolditalic {
      font-family: $font-family-semibolditalic;
    }
  }
}
